import $ from 'jquery';
import { addInert, removeInert, mediaQueryDesktop } from './useInert.js';

export default class MobileNav {
  constructor(el) {
    this.el = el;
    this.mainNav = document.querySelector('.js-main-nav');
    this.init();

    if (this.el.getAttribute('data-isfixedonscrollpast')) {
      this.bindListeners();
    }
  }

  init() {
    this.attachEvents();
    !mediaQueryDesktop().matches && this.mainNav.setAttribute('inert', '');
  }

  attachEvents() {
    const menuButton = this.el.querySelector('.menu');
    const searchToggle = this.el.querySelector("[data-target='#search-overlay']");
    const searchModal = document.querySelector('.js-search-overlay');
    const dealerModal = document.querySelector('.js-find-dealer');

    menuButton.addEventListener('click', (e) => this.toggleMainNav(e));
    if (searchToggle != null) {
      searchToggle.addEventListener('click', (event) => {
        event.preventDefault();
        searchModal.removeAttribute('inert');
        this.openTargetOverlay(event.target);
      });
    }

    mediaQueryDesktop().addEventListener('change', (e) => {
      e.matches ? this.mainNav.removeAttribute('inert') : this.mainNav.setAttribute('inert', '');
      searchModal.removeAttribute('inert');
      dealerModal.removeAttribute('inert');
    });
  }

  openTargetOverlay(el) {
    const targetId = el.getAttribute('data-target'),
      targetEl = document.querySelector(targetId),
      targetInput = targetEl.querySelector('input');

    targetEl.classList.add('open');
    if (window.dataLayer) {
      dataLayer.push({
        event: 'open-' + targetId.replace('#', ''),
      });
    }
    if (targetInput !== null) {
      targetInput.focus();
    } else {
      document.documentElement.classList.add('overlay-hidden-html');
    }
  }

  closeTargetOverlay(el) {
    const targetId = el.getAttribute('data-target'),
      targetEl = document.querySelector(targetId),
      targetInput = targetEl.querySelector('input');

    targetEl.classList.remove('open');
    if (targetInput !== null) {
      targetInput.blur();
    } else {
      document.documentElement.classList.remove('overlay-hidden-html');
    }
  }

  toggleMainNav(e) {
    const productsLi = this.mainNav.querySelector('li.products');
    const backButton = this.mainNav.querySelector('.back[data-nav-state]');

    document.activeElement.blur();
    this.mainNav.classList.toggle('active');

    if (productsLi) {
      productsLi.click();
      productsLi.focus();
      productsLi.blur();
    }

    document.body.classList.toggle('nav-open');

    if (this.mainNav.classList.contains('active')) {
      e.target.classList.add('active');
      backButton.setAttribute('data-nav-state', 'top');
      addInert([document.querySelector('.js-mobile-nav'), this.mainNav]);
      this.mainNav.focus();
    } else {
      e.target.classList.remove('active');
      backButton.setAttribute('data-nav-state', 'idle');
      removeInert(e.target);
      !mediaQueryDesktop().matches && this.mainNav.setAttribute('inert', '');

      let event = new MouseEvent('menuclosed', {
        bubbles: true,
        cancelable: true,
      });
      document.dispatchEvent(event);
    }
  }

  // ! this is a quick-n-dirty copy of fixedOnScrollPast, needs to be cleaned to import() that dynamically instead.
  bindListeners() {
    window.addEventListener(
      'scroll',
      () => {
        this.handleScroll();
      },
      true,
    );

    window.addEventListener(
      'touchmove',
      () => {
        this.handleScroll();
      },
      true,
    );

    [...this.el.querySelectorAll('.product-sub-nav-link')].forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        if (!navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
          e.preventDefault();

          const targetAnchor = anchor.getAttribute('href').replace('#', '');
          const targetEle = document.getElementById(targetAnchor);

          this.scrollTo(targetEle);
        }
      });
    });
  }

  scrollTo(target) {
    const scrollToOffset = $(target).offset().top - this.el.clientHeight;
    $('html, body').animate(
      {
        scrollTop: scrollToOffset,
      },
      500,
    );
  }

  handleScroll() {
    if (
      this.el.classList.contains('is-fixed') &&
      document.querySelector('.js--cta-bar-palceholder').getBoundingClientRect().top >= 1
    ) {
      this.unfixHeader();
      return;
    }
    if (this.el.getBoundingClientRect().top <= 0) {
      this.fixHeader();
    }
  }

  fixHeader() {
    if (!this.el.classList.contains('is-fixed')) {
      this.cloneHeader();
      this.el.classList.add('is-fixed');
    }
  }

  unfixHeader() {
    if (this.el.classList.contains('is-fixed')) {
      document.querySelector('.js--cta-bar-palceholder').remove();
      this.el.classList.remove('is-fixed');
    }
  }

  cloneHeader() {
    const placeholder = this.el.cloneNode(true);
    placeholder.classList.add('js--cta-bar-palceholder');
    this.el.parentNode.insertBefore(placeholder, this.el);
  }
}
